import { AlertDialog, DateString } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { MaintenanceNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { useUserTimezone } from "client/Hooks";
import { TimeZone } from "client/DateAndTime/timezones";
import styles from "./MaintenanceActivityInvocation.module.less";

export type MaintenanceItemActivityInvocationProps = {
	data: MaintenanceNotificationDataViewModel;
	onDismiss: () => void;
};

export const MaintenanceActivityInvocation = (props: MaintenanceItemActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const userTimezone: TimeZone = useUserTimezone();

	const {
		appName,
		start,
		end,
		message
	} = data;

	return (
		<AlertDialog
			title={localize("_MaintenanceDetailsForAppName").replace("{AppName}", appName)}
			onClose={onDismiss}
			showCloseButton
			trackingId="app-maintenance-window-dialog"
		>
			<span>
				{localize("_Starts")}:{" "}
				<DateString
					value={start}
					format="DMYT"
					timezone={userTimezone}
				/>
			</span>
			<p className={styles.endDate}>
				{localize("_Ends")}:{" "}
				<DateString
					value={end}
					format="DMYT"
					timezone={userTimezone}
				/>
			</p>
			<p>{message}</p>
		</AlertDialog>
	);
};

MaintenanceActivityInvocation.displayName = "MaintenanceActivityInvocation";